// import Swal from "sweetalert2";

// export const Popup = ({
//   title,
//   text,
//   icon,
//   confirmButtonText,
//   onConfirm,
//   cancelButtonText,
//   onCancel,
//   note,
// }) => {
//   Swal.fire({
//     title: title || "Default Title",
//     text: text || "Default Text",
//     icon: icon || "info",
//     confirmButtonText: confirmButtonText || "OK",
//     showCancelButton: !!cancelButtonText,
//     cancelButtonText: cancelButtonText || "Cancel",
//     footer: note
//       ? `<small style="color: #6c757d;">${note}</small>`
//       : undefined, // 👈 note added here
//     customClass: {
//       confirmButton: "btn button-primary",
//       cancelButton: "btn button-secondary"
//     },
//   }).then((result) => {
//     if (result.isConfirmed && onConfirm) {
//       onConfirm(); // Call the onConfirm function if the user clicks "OK"
//     } else if (result.dismiss === Swal.DismissReason.cancel && onCancel) {
//       onCancel(); // Call the onCancel function if the user clicks "Cancel"
//     }
//   });
// };





import Swal from "sweetalert2";

export const Popup = ({
  title,
  text,
  icon,
  confirmButtonText,
  onConfirm,
  cancelButtonText,
  onCancel,
  note,
}) => {
  Swal.fire({
    title: title || "Default Title",
    icon: icon || "info",
    html: `
  <div class="text-left">
    <p class="popup-text">${text}</p>
    ${note ? `<div class="popup-note"><strong>Note:</strong> ${note}</div>` : ""}
  </div>
`,
    confirmButtonText: confirmButtonText || "OK",
    showCancelButton: !!cancelButtonText,
    cancelButtonText: cancelButtonText || "Cancel",
    customClass: {
      confirmButton: "btn button-primary",
      cancelButton: "btn button-secondary",
    },
  }).then((result) => {
    if (result.isConfirmed && onConfirm) {
      onConfirm();
    } else if (result.dismiss === Swal.DismissReason.cancel && onCancel) {
      onCancel();
    }
  });
};